{
  "title": "PoultryNEXT Layers",
  "title_Agrifirm": "PoultryNEXT Layers",
  "home": "Domicile",
  "save": "sauver",
  "save-and-next-week": "Enregistrez et passez à la semaine prochaine",
  "week": "La semaine",
  "app": {
    "flock": "Lot",
    "settings": "Paramètres",
    "management": "Gestion",
    "products": "Produits",
    "advices": "Conseils",
    "feed-advice": "Avis alimentaire ",
    "reference-scheme": "Avis alimentaires standard",
    "breeders": "Éleveurs"
  },
  "settings": {
    "navigation": {
      "barns": "Étables",
      "sustainability": "Durabilité"
    },
    "barn": "Étable",
    "no-barns": {
      "description": "Ajoutez une étable et elle apparaîtra ici.",
      "title": "Pas d' étables ajoutés"
    },
    "barn-item": {
      "title-create": "Créer une étable",
      "title-edit": "Modifier l'étable",
      "add": "Ajouter",
      "area": "Surface",
      "name": "Description de l'étable",
      "error-name-duplicate": "Ce nom d'étable est déjà utilisé. Entrez un nom d'étable unique",
      "error-name-required": "Entrez le nom de la grange",
      "error-surface-area": "Entrez la surface",
      "delete-item": "Voulez-vous supprimer l'étable ?",
      "silo": "Silo"
    }
  },
  "egg-marketing-standards": {
    "organic": "Biologique",
    "free-range": "Parcours extérieur",
    "cage-free": "Poulets au sol",
    "caged": "En cage"
  },
  "flock-saved": "Le lot est sauvé.",
  "confirm-delete-flock": "Êtes-vous sûr de vouloir supprimer le lot ?",
  "flock-deleted": "Le lot est supprimé.",
  "flock-overview": {
    "flock": "Lot",
    "placeholder": "Sélectionnez un lot",
    "selector-option-flock": "Lot",
    "selector-option-barn": "Étable",
    "print": "Imprimer le(s) rapport(s)",
    "new-flock": "Nouveau lot",
    "add-week": "Ajouter une semaine",
    "download-all": "Rapport du lot (.pdf)",
    "download-animal-count": "Rapport de comptage des animaux (.pdf)",
    "download-summary": "Télécharger le résumé (.pdf)",
    "panel": {
      "arrival-title": "Mise en place",
      "weekregistrations-title": "Inscriptions de la semaine",
      "departure-title": "Départ",
      "add-arrival": "Ajouter une mise en place",
      "add-departure": "Ajouter un départ",
      "edit-arrival": "Modifier la mise en place",
      "edit-departure": "Modifier le départ",
      "emptymessage-arrival": "Vous devez d'abord ajouter une mise en place pour ce lot.",
      "emptymessage-weekregistrations": "Vous n'avez pas rempli d'inscriptions hebdomadaires jusqu'à présent.",
      "emptymessage-departure": "Vous n'avez pas encore défini le départ.",
      "flock-id": "ID du lot",
      "egg-marketing-standard": "Norme de commercialisation des œufs",
      "hatchery-name": "Couvoir",
      "amount-of-hens": "Nombre de poules",
      "breed-name": "Race",
      "barn-name": "Étable",
      "chick-birthdate": "Date de naissance",
      "arrival-date": "Date de mise en place",
      "delete": "Supprimer le lot",
      "departure-date": "Date de départ",
      "departure-amount": "Nombre",
      "departure-weight": "Poids de la pondeuse (g)",
      "housing-system": "Système de logement",
      "amount-of-roosters": "Quantité de coqs",
      "delete-breeder-flock": "Supprimer le lot reproducteur",
      "feed-system-hens": "Alimentation poules",
      "feed-system-roosters": "Alimentation coqs",
      "drink-system": "Abreuvement",
      "hen-weight": "Poids de la pondeuse (g)",
      "rooster-weight": "Poids du coq (g)",
      "nest": "Nid",
      "rearing-organization": "Éleveur",
      "transport-distance": "Transport de l'éleveur (km)"
    },
    "week-registrations": {
      "sortByAscending": "Semaine ascendante",
      "sortByDescending": "Semaine décroissante",
      "edit": "Modifier",
      "delete": "Supprimer",
      "kpis": {
        "AverageEggWeight": "Poids moyen des œufs",
        "AverageEggWeightPerLayerPerDay": "Masse d'œufs",
        "AverageLayerWeight": "Poids pondeuse",
        "EggCountPerLayerInProduction": "Oeufs pp mise en place",
        "EggCountPerLayerInProductionCumulative": "Oeufs pp mise en place cum",
        "FeedConsumption": "Aliments",
        "FeedConsumptionPerLayerInProduction": "Aliments pp mise en place",
        "FeedConsumptionPerLayerInProductionCumulative": "Aliments pp mise en place cum (kg)",
        "FeedConsumptionPerLayerPerDay": "Aliments pppj",
        "FeedConsumptionPerLayerPerDayCumulative": "Aliments pppj cum",
        "FeedConversionRate": "Conversion alimentaire",
        "FeedConversionRateCumulative": "conversion alimentaire cum",
        "FeedToEggRatio": "Quantité d'aliments par œuf",
        "MortalityCount": "Mortalité",
        "MortalityRate": "Taux de mortalité",
        "MortalityRateCumulative": "Taux de mortalité cum",
        "RateOfLay": "Taux de ponte",
        "TotalEggCount": "Nombre d'œufs totales",
        "TotalEggCountSecondGrade": "Nombre d'œufs 2e qualité",
        "TotalEggWeight": "Poids totale œufs",
        "TotalEggWeightPerLayerInProductionCumulative": "Poids d'œuf pp cum (kg)",
        "WaterConsumption": "Eau",
        "WaterToFeedRatio": "Eau/aliment",
        "SecondFeedConsumption": "Deuxième aliment"
      },
      "breeder-kpis": {
        "EggCount": "Nombre d'œufs",
        "EggWeightInGrams": "Poids des œufs",
        "FertilityPercentage": "Fertilité",
        "HatchPercentage": "Taux d'éclosion",
        "HatchingEggCount": "Nombre d'œufs à couver",
        "HenCount": "Nombre de poules",
        "HenFeedIntakeInGrams": "Consommation aliment poules",
        "HenMortality": "Mortalité poules",
        "HenWeight": "Poids des poules",
        "LightHours": "Heures de lumière",
        "LightIntensity": "Intensité lumineuse",
        "RoosterCount": "Nombre de coqs",
        "RoosterMortality": "Mortalité coqs",
        "RoosterPercentage": "Pourcentage de coqs",
        "RoosterFeedIntakeInGrams": "Consommation aliment coqs",
        "RoosterWeight": "Poids des coqs",
        "RateOfLay": "Taux de ponte",
        "AverageEggWeight": "Poids moyen des œufs",
        "EggMassPerBreeder": "Masse d'œufs par reproducteur",
        "FeedPerBreeder": "Aliment par reproducteur",
        "FeedPerBreederPerDay": "Aliment par reproducteur par jour",
        "FeedPerHatchedEgg": "Aliment par œuf à couver",
        "FeedToEggRatio": "Aliment par œuf",
        "FeedConversion": "Indice de consommation",
        "WaterToFeedRatio": "Rapport eau/aliment",
        "MortalityRate": "Taux de mortalité",
        "ProductionFigure": "Indice de production",
        "HatchedEggsPerPlacedHen": "Œufs à couver par poule placée",
        "HenMortalityRate": "Taux de mortalité des poules",
        "RoosterMortalityRate": "Taux de mortalité des coqs",
        "TotalFeedPerWeek": "Aliment total (semaine)",
        "WaterInLiters": "Eau",
        "HenWaterIntakeInLiters": "Consommation eau poules",
        "RoosterWaterIntakeInLiters": "Consommation eau coqs",
        "HatchedEggsCumulative": "Œufs éclos cumulatif",
        "HatchPercentageCumulative": "Taux d'éclosion cumulatif",
        "RateOfLayCumulative": "Taux de ponte cumulatif",
        "AverageEggWeightCumulative": "Poids moyen des œufs cumulatif",
        "EggMassPerBreederCumulative": "Masse d'œufs par reproducteur cumulatif",
        "FeedPerBreederCumulative": "Aliment par reproducteur cumulatif",
        "FeedPerBreederPerDayCumulative": "Aliment par reproducteur par jour cumulatif",
        "FeedPerHatchedEggCumulative": "Aliment par œuf à couver cumulatif",
        "FeedToEggRatioCumulative": "Aliment par œuf cumulatif",
        "FeedConversionCumulative": "Indice de consommation cumulatif",
        "WaterToFeedRatioCumulative": "Rapport eau/aliment cumulatif",
        "MortalityRateCumulative": "Taux de mortalité cumulatif",
        "HatchedEggsPerPlacedHenCumulative": "Œufs éclos par poule placée cumulatif",
        "HenMortalityRateCumulative": "Taux de mortalité des poules cumulatif",
        "RoosterMortalityRateCumulative": "Taux de mortalité des coqs cumulatif"
      },
      "view-filters": {
        "kpis": "ICP",
        "manual-input": "Encodage manuelle",
        "moult": "Mue",
        "remarks": "Remarques",
        "detailed": "Détaillé"
      },
      "filters": {
        "title": "Paramètres du graphique",
        "description": "Vous trouverez ici les paramètres du graphique.",
        "labels": {
          "breed-category-name": "Catégorie de race",
          "egg-marketing-standard": "Norme de commercialisation des œufs",
          "breed-name": "Race",
          "data-sources": "Sources de données affichées",
          "other-flock-placeholder": "Sélectionnez un lot",
          "selector-option-barn": "Étable"
        },
        "breed-categories": {
          "overall": "Moyenne",
          "white": "blanche",
          "brown": "brun"
        },
        "egg-marketing-standards": {
          "0": "Biologique",
          "1": "En plein air",
          "2": "Au sol",
          "3": "En cage"
        },
        "breeds": {
          "Overall": "Moyenne"
        },
        "chart-lines": {
          "current-flock": "Lot sélectionné",
          "breeders-reference-benchmark": "Normes du race",
          "porphyrio-benchmark": "Référence Porphyrio",
          "other-flock": "Autre lot",
          "other-flock-lower-case": "autre lot"
        }
      },
      "benchmark": {
        "title": "Aperçu hebdomadaire de",
        "description": "Vous trouverez ici un aperçu hebdomadaire des KPI :",
        "breedersReference": "Normes du race",
        "cumulative": "Cumulatif",
        "porphyrioBenchmark": "Référence Porphyrio",
        "flocks": "Lots",
        "error": {
          "no-data-sources-title": "Aucune source de données disponible",
          "no-data-sources-description": "Un aperçu hebdomadaire ne peut pas être affiché car aucune source de données n'a été sélectionnée.",
          "no-data-title": "Pas de données disponibles",
          "no-data-description": "Aucune donnée n'est disponible pour une ou plusieurs sources de données activées."
        },
        "axis": {
          "week": "Semaine",
          "values": "Valeurs"
        }
      },
      "weekregistration-download": "Télécharger le modèle",
      "weekregistration-upload": "Importé",
      "weekregistration-select-file": "Sélectionner un fichier...",
      "weekregistration-upload-csv-title": "Sélectionner un fichier CSV à importer",
      "upload-csv-message": "Les colonnes ne doivent pas être supprimées du modèle, même si elles sont vides. Les champs peuvent être laissés vides.",
      "upload-csv-notification": "Sélectionner un fichier CSV à importer",
      "weekregistration-select-interval-type": "Type d'intervalle",
      "interval-type-Day": "Jour",
      "interval-type-Week": "Semaine",
      "validation-errors": {
        "total-must-be-100": "Le total doit être égal à 100",
        "date-is-not-valid-title": "La date est incorrecte",
        "date-is-not-valid-description": "La date est incorrecte"
      },
      "date": "Date",
      "days": "Jours",
      "weeks": "Semaines",
      "jump-to-week": "Aller a la semaine"
    },
    "no-flocks": {
      "title": "Pas de lots",
      "description": "Ajoutez un lot et il apparaîtra ici."
    },
    "unassigned": "Non attribué",
    "new-breeder-flock": "Nouveau lot reproducteur"
  },
  "week-registration": {
    "mortality": "Mortalité",
    "eggsAmount": "Quantité totale d'œufs",
    "eggsAmountSecondKind": "Quantité d'oeufs 2ème type",
    "eggWeight": "Poids des œufs",
    "forage": "Aliments",
    "water": "Eau",
    "henWeight": "Poids (poule)",
    "moult": "Mue",
    "isInMoult": "Mue?",
    "isInMoultMessage": "Les poules sont-elles en mue cette semaine ?",
    "moult-true": "Oui",
    "moult-false": "Non",
    "remarks": "Remarques",
    "amountOfHensStartOfWeek": "Nombre de poules en début de semaine",
    "amountOfRoostersStartOfWeek": "Nombre de coqs en début de semaine",
    "amountOfHensStartOfFlock": "Nombre de poules au début du lot",
    "amountOfRoostersStartOfFlock": "Nombre de coqs au début du lot",
    "henMortality": "Mortalité (poule)",
    "roosterMortality": "Mortalité (coq)",
    "roosterWeight": "Poids (coq)",
    "henFeedIntakeInGrams": "Consommation alimentaire en grammes (poule)",
    "roosterFeedIntakeInGrams": "Consommation alimentaire en grammes (coq)",
    "henWaterIntakeInLiters": "Consommation d'eau en litres (poule)",
    "roosterWaterIntakeInLiters": "Consommation d'eau en litres (coq)",
    "eggCount": "Nombre d'œufs",
    "hatchingEggCount": "Nombre d'œufs à couver",
    "eggWeightInGrams": "Poids des œufs (en grammes)",
    "fertilityPercentage": "Pourcentage de fertilité (1 décimale)",
    "hatchPercentage": "Pourcentage d'éclosion (1 décimale)",
    "lightHours": "Heures de lumière",
    "lightIntensity": "Intensité lumineuse",
    "breed": "Race",
    "barn": "Étable",
    "dateOfBirth": "Date de naissance",
    "arrivalDate": "Date de mise en place",
    "week": "La semaine",
    "week-start": "Début de la semaine",
    "registration": "enregistrer",
    "period": "Periode",
    "out-of-range": "Cette valeur est hors limites.",
    "whole-number-required": "Saisissez un nombre entier (sans décimales).",
    "hatching-egg-count-exceeds-egg-count": "Le nombre d'œufs à couver ne peut pas dépasser le nombre d'œufs",
    "hatch-greater-than-fertility": "Le pourcentage d'éclosion doit être inférieur au pourcentage de fertilité",
    "too-much-mortality": "La somme de toutes les mortalités est supérieure au nombre de poules au début de la semaine !",
    "forageProduct": "Aliments",
    "secondForageToggle": "Ajouter un deuxième aliment",
    "secondForage": "Deuxième aliment",
    "secondForageProduct": "Deuxième aliment",
    "weekly-registrations": "Régistrations hebdomadaires observatifs",
    "daily-registrations": "Régistrations journaliers observatifs"
  },
  "arrival-detail": {
    "title-edit": "Modifier la mise en place",
    "title-create": "Créer une mise en place",
    "flock-name": "Nom du lot",
    "barn": "Étable",
    "chick-birthdate": "Date de naissance",
    "arrival-date": "Date de mis en place",
    "production-period-start-date": "Début de la période de production",
    "breed": "Race",
    "amount-of-hens": "Quantité de poules",
    "egg-marketing-standard": "Norme de commercialisation des œufs",
    "hatchery": "Couvoir",
    "input-mode": "Procédé d'entrée",
    "input-mode-per-day": "du quotidien",
    "input-mode-per-week": "Hebdomadaire",
    "input-mode-advanced": "Avancée",
    "advanced-link": "Entrer les paramètres avancés >",
    "back-to-general-data": "< retour",
    "advanced-settings-title": "Paramètres de saisie avancés",
    "days": "jours",
    "age-start-production-period": "Âge au début de la ponte",
    "housing-system": "Système de logement",
    "bedding-type": "Type de litière",
    "bedding-amount": "Quantité de litière",
    "transport-distance": "Transport de l'éleveur",
    "transport-distance-error": "Le transport de l'éleveur doit être un nombre compris entre 0 et 1000",
    "bedding-amount-error": "La quantité de litière doit être un nombre positif",
    "time-in-free-range": "Temps présent en plein air",
    "time-in-free-range-error": "Temps présent en plein air doit etre un nombre entre 0 et 100",
    "hen-weight": "Poids de la pondeuse",
    "hen-weight-error": "Le poids de la pondeuse doit être un nombre positif",
    "hen-weight-comparison-error": "Le poids doit être inférieur à celui du départ",
    "minimum-amount-of-hens-error": "Le nombre de poules doit être un nombre positif",
    "rearing-organization": "Organisation d'élevage",
    "amount-of-roosters": "Quantité de coqs",
    "minimum-amount-of-roosters-error": "Le nombre de coqs doit être un nombre positif",
    "show-rooster-fields": "Enregistrer les coqs",
    "rooster-weight": "Poids du coq",
    "rooster-weight-error": "Le poids du coq doit être un nombre positif",
    "feed-system-hens": "Système d'alimentation poules",
    "feed-system-roosters": "Système d'alimentation coqs",
    "drink-system": "Système d'abreuvement",
    "nest": "Nid"
  },
  "departure-detail": {
    "amount": "Nombre",
    "departureDate": "Date de départ",
    "henWeightInGrams": "Poids de la pondeuse",
    "eggs-price": "Prix des œufs",
    "eggs-price-error": "Le prix des œufs doit être un nombre positif",
    "pieces": "pièces",
    "hens-price": "Prix des poules abattues",
    "hens-price-error": "Le prix des poules abattues doit être un nombre positif",
    "eggs-price-second-kind": "Prix des œufs de deuxième qualité",
    "eggs-price-second-kind-error": "Le prix des œufs de deuxième choix doit être un nombre positif",
    "hen-weight-error": "Le poids de la pondeuse doit être un nombre positif",
    "hen-weight-comparison-error": "Le poids au départ doit être supérieur au poids à l'arrivée",
    "minimum-amount-of-hens-error": "Le nombre de poules doit être un nombre positif",
    "amount-of-hens-comparison-error": "Le nombre de poules ne peut être supérieur à celui de l'arrivée",
    "departure-date-comparison-error": "La date de départ doit être égale ou postérieure à la première date autorisée"
  },
  "report": {
    "title_all": "Rapport du lot",
    "title_summary": "Rapport d'apercu du lot",
    "title_animalcount": "Rapport de comptage des animaux",
    "animalcount": {
      "year": "Rapport de comptage des animaux par année",
      "year-placeholder": "- sélectionnez une année -",
      "farmcompany": "Entreprise agricole",
      "customernr": "Numéro de client",
      "contactperson": "Personne de contact",
      "location": "Lieu",
      "flock": "Lot",
      "barn": "Étable",
      "arrivaldate": "Date d'arrivée",
      "arrivalamount": "Montant d'arrivée",
      "departuredate": "Date de départ",
      "departureamount": "Montant départ",
      "mutationdate": "Date de mutation",
      "reason": "Raison",
      "mutation": "Mutation",
      "amountbeforemutation": "Montant avant mutation",
      "amountaftermutation": "Montant après mutation",
      "numberofdays": "Nombre de jours",
      "animaldays": "Journées d'animaux",
      "average": "Présent moyen",
      "total": "Total",
      "reasons": {
        "EndOfLastYear": "Fin de l'année dernière",
        "Departure": "Départ",
        "Mortality": "Mortalité",
        "EndOfYear": "Fin d'année",
        "Today": "Aujourd'hui",
        "Arrival": "Arrivée"
      }
    },
    "customer-details": {
      "header": "Informations client",
      "customer-number": "Numéro de client",
      "name": "Nom",
      "address": "Adresse",
      "city": "Code postal et ville",
      "phone": "Téléphone",
      "location-name": "Nom de location",
      "location-address": "Adresse de location",
      "location-city": "Location code postal et ville",
      "location-phone": "Location téléphone "
    },
    "flock-details": {
      "header": "Détails du lot",
      "flock": "Lot",
      "breed": "Race",
      "amount-of-hens": "Nombre de poules",
      "marketing-standard": "Norme de commercialisation",
      "arrival-date": "Date d'arrivée",
      "departure-date": "Date de départ",
      "age-start-production-period": "Âge début de production",
      "days": "journées",
      "barn": "Étable"
    },
    "week-details": {
      "header": "régistration par semaine",
      "week": "La semaine",
      "cumulative": "Cumul",
      "weekStart": "Début de la semaine",
      "AverageEggWeight": "Poids moyen des œufs (g)",
      "AverageEggWeightPerLayerPerDay": "Masse d'œuf (g)",
      "AverageLayerWeight": "Poids de la poule (g)",
      "EggCountPerLayerInProduction": "Oeufs ppmp",
      "EggCountPerLayerInProductionCumulative": "Oeufs ppmp cum",
      "FeedConsumption": "Poids d'alimentation (kg)",
      "FeedConsumptionPerLayerInProduction": "Poids d'alimentation ppmp(kg)",
      "FeedConsumptionPerLayerInProductionCumulative": "Poids d'alimentation ppmp cum (kg)",
      "FeedConsumptionPerLayerPerDay": "Aliment pppj (g)",
      "FeedConsumptionPerLayerPerDayCumulative": "Aliment pppj cum(g)",
      "FeedConversionRate": "Conversion alimentaire",
      "FeedConversionRateCumulative": "conversion alimentaire cum",
      "FeedToEggRatio": "Aliment/Oeuf (g)",
      "MortalityCount": "Mortalité",
      "MortalityRate": "Taux de mortalité",
      "MortalityRateCumulative": "Taux de mortalité cum",
      "RateOfLay": "Taux de ponte",
      "TotalEggCount": "Nombre d'œufs total",
      "TotalEggCountSecondGrade": "Nombre d'œufs deuxième choix",
      "TotalEggWeight": "Poids total des œufs (kg)",
      "TotalEggWeightPerLayerInProductionCumulative": "Poids d'œufs ppmpcum (kg)",
      "WaterConsumption": "Eau (L)",
      "WaterToFeedRatio": "Eau/Alimentation",
      "SecondFeedConsumption": "2ème aliment (kg)"
    }
  },
  "validation-error": {
    "required": "Champs obligatoire",
    "title": "erreur de validation",
    "description": "Tous les données doivent être remplis."
  },
  "delivery-title": "Livraisons",
  "delivery": {
    "search-placeholder": "Rechercher dans les bons de livraison",
    "overview-title": "Présentation des livraisons",
    "empty-title": "Aucune livraison trouvée",
    "empty-description": "Aucune livraison n'a été trouvée pour cet location",
    "overview-table": {
      "deliveryDate": "Date",
      "deliveryNote": "Bon de livraison",
      "orderNr": "N° de commande",
      "productNr": "Produit ID",
      "productName": "Nom du produit",
      "amount": "Nombre",
      "units": "Unités",
      "isActive": "Actif",
      "flock": "Lot",
      "edit-title": "Modifier la Livraison du lot"
    }
  },
  "product-title": "Produits",
  "product-save": "Sauvegarder le produit",
  "product-saved": "Produit sauvegardé !",
  "product-overview": {
    "title": "Aperçu du produit",
    "overview": {
      "productName": "Nom",
      "productCode": "Code produit",
      "isActive": "Actif",
      "productType-Feed": "Aliment",
      "productType-Additive": "Additif",
      "type": "Type de produit"
    },
    "no-products": {
      "title": "Aucun produit trouvé",
      "description": "En cliquant sur Ajouter, un produit peut être créé."
    },
    "delete-confirmation-title": "Supprimer un produit",
    "delete-confirmation-message": "Êtes-vous sûr de vouloir supprimer ce produit ?",
    "country": "Pays"
  },
  "create-product": {
    "title-create": "Ajouter un produit",
    "title-edit": "Modifier le produit :",
    "product-name": "Nom du produit",
    "product-code": "Code produit",
    "error-product-name": "Veuillez indiquer le nom du produit.",
    "error-product-code": "Veuillez indiquer le code du produit.",
    "error-code-name-already-in-use": "Veuillez utiliser une combinaison unique de nom et de code",
    "product-type": {
      "label": "Type de produit",
      "Feed": "Aliment",
      "Additive": "Additif"
    },
    "error-product-type": "Le type de produit est obligé"
  },
  "countries": {
    "BE": "Belgique",
    "DE": "Allemagne",
    "FR": "France",
    "NL": "Pays-Bas",
    "JO": "Jordanie",
    "NG": "Nigéria",
    "TZ": "Tanzania",
    "KE": "Kenya",
    "UG": "Uganda"
  },
  "confirm-delete-flock-week-registration": "Êtes-vous sûr de vouloir supprimer la registration par semaine ?",
  "flock-week-registration-deleted": "La registration par semaine a été supprimé.",
  "feed-advice": {
    "overview": {
      "title": "Résumé d'avis alimentaire",
      "empty": {
        "title": "Dates d'avis alimentaire pas disponibles",
        "description": "Il n'y a pas de dates d'avis alimentaire disponibles pour le moment."
      },
      "table-header": {
        "name": "Nom",
        "created": "Crée",
        "updated": "Mise à jour",
        "updatedAdvisorName": "Mise à jour par",
        "isActive": "Actif"
      },
      "buttons": {
        "add": "Ajouter un avis alimentaire",
        "edit": "Ajuster",
        "delete": "Supprimer"
      }
    },
    "create-from-reference": {
      "title": "Créer un avis alimentaire",
      "scratch-title": "commencer un nouveau avis alimentaire",
      "scratch-option-title": "commencer un avis alimentaire",
      "scratch-button": "Comencer avec un avis blanco",
      "scratch-option-subtitle": "Il s'agit d'un avis blanco",
      "reference-schemes-title": "Choisir un avis standard comme base",
      "reference-schemes-button": "Commencer par ",
      "product": "Produit",
      "products": "Produits",
      "additive": "Additif",
      "additives": "Additifs"
    },
    "dialog": {
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet avis alimentaire ?",
      "deleteConfirmWhenInUse": "Cet avis alimentaire est lié à un lot, êtes-vous sûr de vouloir supprimer cet avis alimentaire ?"
    },
    "create": {
      "print": "Imprimer",
      "title": "Avis alimentaire",
      "name": "Nom de l'avis alimentaire",
      "error-name": "Nom avis alimentaire est obligatoire",
      "description": "Description",
      "description-placeholder": "Description d'avis alimentaire",
      "product-placeholder": "- sélectionner un produit -",
      "add-product": "Ajouter un produit",
      "table-header": {
        "productName": "Produit",
        "ageFrom": "Âge à partir de (semaines)",
        "ageTo": "Âge jusqu'à (semaines)",
        "comment": "Commentaires",
        "age": "Âge (semaines)",
        "dosage": "Avis dosage (kg/tonne)",
        "applicationMoment": "Demande d'age"
      },
      "created": "Crée",
      "updated": "Mise à jour",
      "validation-error": {
        "title": "Erreur(s) de validation",
        "feedadvice-name": "Le nom de l'avis alimentaire est obligatoire",
        "age-from": "L'âge de est obligatoire",
        "product": "Le produit est nécessaire",
        "age-to": "L'âge jusqu'à est obligatoire (sauf à la dernière ligne)",
        "age-min-max": "L'âge de départ doit être inférieur à l'âge d'arrivée."
      },
      "products": "Conseil de base",
      "additives": "Additifs",
      "show-additives": "Afficher les additifs",
      "add-additive": "Ajouter un additif"
    },
    "print": {
      "farmcompany": "Entreprise",
      "customernr": "Numéro de client",
      "contactperson": "Personne de contact",
      "location": "Location",
      "customerservice": "Service clientèle",
      "table-header": {
        "productName": "Produit",
        "comment": "Commentaires",
        "dosage": "Dosage",
        "units_kgton": "kg/tonne",
        "applicationMoment": "L'age à l'application",
        "units_weeks": "(semaines)",
        "age": "L'âge"
      }
    }
  },
  "reference-scheme": {
    "overview": {
      "title": "Résumé de l'avis alimentaire standard ",
      "empty": {
        "title": "Avis alimentaire standard indisponible",
        "description": "Il n'y a pas d'avis alimentaire standard disponible pour le moment."
      },
      "table-header": {
        "name": "Nom",
        "created": "Crée",
        "updated": "Mise à jour",
        "updatedAdvisorName": "Mise à jour par",
        "isActive": "Actif"
      },
      "buttons": {
        "add": "Ajouter l'avis alimentaire standard",
        "edit": "Editer",
        "delete": "Supprimer"
      },
      "country": "Pays"
    },
    "dialog": {
      "deleteConfirm": "Êtes-vous sûr de supprimer l'avis alimentaire standard ?"
    },
    "create": {
      "title": "Avis alimentaire standard",
      "name": "Nom de l'avis alimentaire standard",
      "error-name": "Un nom pour l'avis alimentaire standard est obligatoire.",
      "description": "Description",
      "description-placeholder": "Description de l'avis alimentaire standard",
      "product-placeholder": "- sélectionner un produit -",
      "add-product": "Ajouter un produit",
      "table-header": {
        "productName": "Produit",
        "ageFrom": "Âge à partir de (semaines)",
        "ageTo": "Âge jusqu'à (semaines)",
        "comment": "Commentaires"
      },
      "created": "Crée",
      "updated": "Mise à jour"
    }
  },
  "housing-systems": {
    "aviary": "Volière",
    "cages": "Cages",
    "colony": "Colonie",
    "floor": "Pondeuses au sol",
    "free-range": "En plein air",
    "furnished-cages": "Cages enrichie",
    "organic": "Biologique"
  },
  "sustainability": {
    "workflow": {
      "new-calculation": "Nouveau calcul",
      "requirements-met": "conditions remplies",
      "inputs-title": "Données de calcul",
      "climate-change": "Changement climatique",
      "source": "Source",
      "outputs": {
        "eggs": "Œufs",
        "hens": "Poules de réforme",
        "egg-unit": "kg éq. CO₂ / kg d’œufs",
        "hen-unit": "kg éq. CO₂ / kg de poids vif de poule"
      },
      "requirements-title": "Conditions",
      "data-complete": "Données requises complètes.",
      "saved-result": "Résultat enregistré",
      "previous-calculations": "Calculs précédents",
      "history-description": "Sélectionnez un calcul pour voir son résultat.",
      "results-title": "Résultats du calcul",
      "issue-details": "Afficher les détails",
      "missing-fields": "Données manquantes ou non valides",
      "no-impact-values": "Ce calcul ne contient aucune valeur d’empreinte.",
      "result-errors": "Ce calcul contient des erreurs.",
      "fields": {
        "UnitVolumeType": "Unité de livraison",
        "Co2Total": "CO₂ total",
        "Biogenic": "CO₂ biogénique",
        "FossilExcludingPeatEmissions": "CO₂ fossile hors tourbe",
        "FossilPeatEmissions": "CO₂ de la tourbe",
        "LandUseChange": "Changement d’utilisation des terres",
        "DryMatterAmount": "Matière sèche",
        "RoughProtein": "Protéines brutes",
        "ProductCode": "Code produit",
        "SourceDeliveryLineId": "Source de livraison",
        "SourceIdentifier": "Référence de la source",
        "LocationId": "Site de l’exploitation",
        "DeliveryId": "Livraison",
        "DeliveryLineNumber": "Ligne de livraison",
        "UsedKg": "Kg utilisés",
        "DeliveredKg": "Poids livré",
        "DeliveryType": "Type de livraison",
        "Co2TotalMismatch": "Le total de CO₂ ne correspond pas à la somme du CO₂ biogénique, du CO₂ fossile hors tourbe, du CO₂ provenant de la tourbe et des émissions liées au changement d’utilisation des terres. Demandez à votre conseiller ou au support de vérifier et de corriger les valeurs d’émissions dans les données sources de cette ligne de livraison, puis vérifiez à nouveau les données saisies. Modifier les kg consommés ne résoudra pas cet écart."
      },
      "checking": "Checking saved calculation inputs…",
      "readiness-error": "The input check failed. Try again.",
      "retry": "Try again",
      "ready": "Ready",
      "incomplete": "Needs attention",
      "correct-resources": "Correct farm resources",
      "check-again": "Check inputs again",
      "submitting": "Importing feeds and submitting the calculation…",
      "loading-results": "Loading calculations…",
      "results-error": "Results could not be loaded. Existing calculations are retained.",
      "pending": "Le calcul est en cours. Cette page vérifie les résultats pendant 10 minutes maximum. Vérifiez à nouveau ou revenez plus tard.",
      "failed": "The latest calculation failed or timed out. Check inputs and retry, or refresh the result.",
      "no-results": "No calculation available for this flock.",
      "calculation": "Calculation",
      "history-notice": "This is a saved calculation. Later balance or registration changes do not update it; calculate again to include them.",
      "result-invalid": "This saved result could not be read. Contact support.",
      "requirements": {
        "flock": "Flock and production",
        "farm-resources": "Farm resources",
        "bedding": "Bedding",
        "feeds": "Saved feed balance"
      },
      "issues": {
        "flock-not-found": "This flock is unavailable in the selected farm. Select the correct farm and flock.",
        "flock-dates-invalid": "Correct arrival and departure dates. The flock must be closed.",
        "arrival-data-invalid": "Enter a positive arrival count and hen weight in flock details.",
        "departure-data-invalid": "Enter a positive departure count and hen weight in flock details.",
        "departure-weight-below-arrival": "Departure hen weight must be at least the arrival weight.",
        "production-data-missing": "Complete production registrations, including egg count and egg weight.",
        "farm-resources-missing": "Enter farm resources for the missing year.",
        "farm-resources-not-calculated": "Save farm resources to calculate the allocation for this flock.",
        "bedding-type-missing": "Select bedding type in flock arrival details.",
        "bedding-amount-missing": "Enter the bedding amount in flock arrival details.",
        "feed-balance-not-saved": "Enter and save this flock’s feed balance.",
        "feed-balance-empty": "Save at least one positive used kg quantity in the feed balance.",
        "feed-source-missing": "This exact source is unavailable. Clear its quantity in the feed balance and explicitly enter it against the correct source.",
        "feed-data-invalid": "Delivery source data is incomplete or invalid. Contact support with this line and the listed fields, or correct the source in the feed balance.",
        "feed-settings-missing": "Sustell customer configuration or the farm country is missing. Contact support.",
        "calculation-not-ready": "Saved inputs changed or are incomplete. Correct the issues and try again.",
        "feed-import-failed": "Feeds could not all be imported or resolved. Correct source data or contact support, then retry. No baseline was submitted.",
        "sustell-submission-failed": "The calculation could not be submitted. Try again or contact support. Previous results are retained."
      },
      "check-results": "Check results again",
      "correct-flock": "Correct flock details and registrations",
      "statuses": {
        "available": "Calculé",
        "failed": "Failed",
        "pending": "Pending",
        "inprogress": "In progress",
        "timedout": "Timed out",
        "missing": "Missing"
      }
    },
    "sustainability": "Durabilité",
    "add-farm-resources": "Ajouter des ressources agricoles",
    "farm-resources": "Consommation d'énergie par an",
    "carbon-footprint": "Empreinte CO2",
    "confirm-delete-farm-resource": "Supprimer la ressource agricole?",
    "farm-resource-deleted": "Ressource agricole supprimée",
    "farm-resource-saved": "Ressource agricole enregistrée",
    "year": "Année",
    "resource": {
      "electricity": "Électricité (kWh)",
      "electricity-photovoltaic": "Électricité Solaire (kWh)",
      "electricity-wind": "Électricité Éolienne (kWh)",
      "natural-gas": "Gaz naturel (m³)",
      "diesel": "Diesel (L)",
      "gasoline": "Essence (L)",
      "coal": "Charbon (KG)",
      "propane-lpg": "Propane / GPL (L)",
      "water": "Eau (m³)",
      "flock-start-date": "Date de début",
      "flock-end-date": "Date de fin",
      "status": "Statut",
      "statuses": {
        "complete": "Complète",
        "partial": "Incomplet",
        "active": "Actif"
      },
      "water-error": "L'eau doit être un nombre positif",
      "electricity-error": "L'électricité doit être un nombre positif",
      "electricity-photovoltaic-error": "L'électricité solaire doit être un nombre positif",
      "electricity-wind-error": "L'électricité éolienne doit être un nombre positif",
      "natural-gas-error": "Le gaz naturel doit être un nombre positif",
      "diesel-error": "Le diesel doit être un nombre positif",
      "gasoline-error": "L'essence doit être un nombre positif",
      "propane-lpg-error": "Le propane / GPL doit être un nombre positif",
      "coal-error": "Le charbon doit être un nombre positif"
    },
    "farm-settings-saved": "Paramètres de la ferme enregistrés",
    "farm-settings-enable-co2-calculation": "Activer les calculs de CO2 pour cette ferme",
    "flock-resources": "Ressources du lot",
    "consumptionEgg": "Valeur des œufs (kg CO2éq / kg œufs)",
    "spentHens": "Valeur des poules abattues (kg CO2éq / kg poids corporel de la poule)",
    "notification-title": "Informations importantes sur les calculs de CO2",
    "notification-description": "Le calcul de l’empreinte carbone est réalisé à l’aide du logiciel d’ACV Sustell. Il repose sur les calculs des émissions de CO2 liées à l’alimentation, conformément à l’instruction Nevedi actuelle. Pour effectuer un calcul correct, toutes les données doivent être saisies de manière complète, telles que les <b>résultats techniques d’un lot, y compris la production, le départ/l’abattage et la consommation d’énergie.</b>\nLes valeurs affichées peuvent être sujettes à modification en raison de l’évolution des connaissances climatiques et des changements ultérieurs dans les systèmes de calcul, ainsi que des évolutions législatives, réglementaires ou des normes applicables. Bien que les informations présentées ici aient été compilées avec soin, aucun droit ne peut en être tiré.",
    "action-text-close": "Cacher",
    "action-text-open": "Montrer",
    "farm-resources-not-complete": "Les ressources du troupeau ne sont pas complètes.",
    "bedding-type-required": "Arrivée - Le type de litière est requis pour le troupeau.",
    "bedding-amount-required": "Arrivée - La quantité de litière est requise pour le troupeau.",
    "hen-weight-required": "Arrivée - Le poids de la poule est requis pour le troupeau.",
    "start-calculation": "Commencer à calculer le CO2",
    "refresh-carbon-footprint": "Actualiser l'empreinte CO2",
    "carbon-footprint-title-error": "Erreur de calcul de l'empreinte carbone",
    "carbon-footprint-title": "Calcul de l’empreinte carbone",
    "carbon-footprint-text": "Le calcul de l’empreinte carbone va commencer. Veuillez patienter pendant que le processus se termine (environ 1 minute).",
    "carbon-footprint-refresh-error-title": "Erreur lors de l’actualisation de l’empreinte carbone",
    "week-registrations-required": "Les données d'enregistrement hebdomadaire sont requises pour le calcul de l'empreinte carbone.",
    "day-registrations-missing": "Les données d'enregistrement quotidien manquent pour certaines périodes de semaine.",
    "week-registrations-incomplete": "Les enregistrements hebdomadaires doivent contenir des données valides pour toute la période du troupeau.",
    "carbon-footprint-500-error-message": "Une erreur s'est produite lors du calcul de l'empreinte carbone. Cela peut être dû au fait que vos données d'enregistrement hebdomadaire sont incomplètes ou manquantes. Veuillez vous assurer d'avoir rempli les données de production (œufs, consommation d'aliments, mortalité, etc.) pour votre période de troupeau avant de réessayer."
  },
  "bedding-types": {
    "NoBedding": "Pas de litière",
    "BarleyStraw": "Paille d’orge",
    "MaizeStover": "Résidus de maïs",
    "OatStraw": "Paille d'avoine",
    "SawDust": "Sciure de bois",
    "SunflowerHusk": "Coque de tournesol",
    "WheatStraw": "Paille de blé",
    "Woodshavings": "Copeaux de bois"
  },
  "feed-systems": {
    "Ketting": "Alimentation a chaine",
    "Pannen": "Alimentation a assiettes",
    "Spiraal": "Alimentation en spirale"
  },
  "drink-systems": {
    "Cups": "Cups",
    "Nippels": "Abreuvoirs a pipette",
    "RondDrinkers": "Abreuvoirs ronds"
  },
  "nests": {
    "WegrolNest": "WegrolNest",
    "Handgeraapt": "Handgeraapt"
  },
  "title_Agravis": "Avidata Legehenne",
  "feed-balance": {
    "weight-unavailable": "Poids inconnu",
    "correction-help": "Pour corriger une ligne indisponible, effacez ses kg utilisés, trouvez la ligne active souhaitée, saisissez les kg et enregistrez. Les quantités ne sont jamais transférées automatiquement. Activez les nouvelles lignes inactives sur la page Livraisons avant d’attribuer des kg.",
    "search": "Rechercher",
    "no-matches": "Aucune livraison ne correspond à ces filtres.",
    "period-start": "Livraisons à partir du",
    "period-end": "Jusqu’au",
    "show-all-dates": "Afficher toutes les livraisons",
    "use-flock-period": "Utiliser la période",
    "period-notice": "Les quantités enregistrées et saisies restent visibles en dehors de la période sélectionnée.",
    "title": "Bilan alimentaire",
    "flock": "Lot",
    "saved": "Enregistré",
    "not-registered": "Non enregistré",
    "delivery-date": "Date de livraison",
    "delivery-number": "Livraison",
    "order-number": "Numéro de commande",
    "delivered-weight": "Poids livré",
    "delivery-note": "Bon de livraison",
    "line-number": "Ligne",
    "feed": "Aliment",
    "delivered": "Livré",
    "used-kg": "Consommé par ce lot (kg)",
    "used-kg-short": "Consommé (kg)",
    "total": "Consommation totale",
    "save": "Enregistrer le bilan",
    "saving": "Enregistrement…",
    "cancel": "Retour aux lots",
    "loading": "Chargement du bilan alimentaire…",
    "empty": "Aucune livraison active ni affectation enregistrée sur ce site.",
    "missing-delivery-line": "Ligne de livraison indisponible",
    "inactive": "Livraison inactive",
    "save-success": "Bilan alimentaire enregistré.",
    "load-error": "Impossible de charger le bilan. Revenez aux lots et réessayez.",
    "unavailable-allocation": "Cette nouvelle affectation ne peut pas être enregistrée. Effacez la quantité et choisissez une ligne de livraison disponible.",
    "delivery-line-unavailable": "Les lignes de livraison ont changé. Actualisez la page avant d’enregistrer à nouveau. Vos modifications non enregistrées seront perdues.",
    "save-error": "Échec de l’enregistrement. Vos modifications sont conservées ; réessayez.",
    "conflict": "Le bilan a été modifié ailleurs. Actualisez la page pour charger la dernière version. Vos modifications non enregistrées seront perdues.",
    "invalid-input": "Saisissez zéro ou une quantité positive en kg, avec trois décimales au maximum.",
    "unsaved-title": "Bilan alimentaire non enregistré",
    "unsaved-message": "Quitter cette page et abandonner vos modifications ?",
    "calculation-notice": "Ces quantités sont enregistrées séparément. Le calcul actuel de l’empreinte n’utilise pas encore ce bilan."
  }
}
